import { render, staticRenderFns } from "./form.pug?vue&type=template&id=542f2b52&lang=pug&external"
import script from "./form.js?vue&type=script&lang=js&external"
export * from "./form.js?vue&type=script&lang=js&external"
import style0 from "./form.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Multiasistencia\\mavalue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('542f2b52')) {
      api.createRecord('542f2b52', component.options)
    } else {
      api.reload('542f2b52', component.options)
    }
    module.hot.accept("./form.pug?vue&type=template&id=542f2b52&lang=pug&external", function () {
      api.rerender('542f2b52', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/index.vue"
export default component.exports